module.exports = __webpack_public_path__ + "img/payment-1.37314114.jpg";